import * as React from "react"
import { Link } from "gatsby"
import {
  IconFacebook,
  IconGooglePlus,
  IconInstagram,
  IconLinkedIn,
  IconTwitter,
  IconYouTube,
} from "../../icons/IconSocial"
import { memo } from "react"

const Footer = memo(() => {
  return (
    <footer
      className={"background-white visibility-auto my-8 mx-5 overflow-x-hidden"}
      itemScope
      itemType="https://schema.org/WPFooter"
    >
      <nav
        className={"mx-auto flex w-96 flex-col gap-2 md:container md:flex-row"}
        itemScope
        itemType="https://schema.org/SiteNavigationElement"
      >
        <div className={"flex-1 leading-8"}>
          <h2 className={"inline-block rounded-xl uppercase text-accent"}>Contact</h2>
          <a
            href={"https://www.grayandsons.com/"}
            className={"block font-black "}
            rel={"noopener"}
            target={"_blank"}
          >
            Gray & Sons Jewelers
          </a>
          <div className={"whitespace-pre-line leading-normal"}>
            9595 Harding Ave{"\n"}
            Surfside (Miami Beach) FL 33154{"\n"}
            <i className="text-sm">(Located across from Bal Harbour Shops){"\n"}</i>
            <b>Store Hours:</b>
            <br />
            Monday - Saturday: 10am to 5pm
            <br />
            <i className="text-sm">
              <nobr>(Open Sundays 11:00am - 5:00pm</nobr> <nobr>during the holiday season,</nobr>{" "}
              <nobr>from Thanksgiving through New Year{"'"}s Eve)</nobr>
            </i>
            <br />
            <a href={"mailto:sell@grayandsons.com"}>sell@grayandsons.com</a>
            <br />
            <a href={"tel:+13057706955"}>tel. 1-305-770-6955</a>
          </div>
        </div>
        <div className={"flex-1 leading-8"}>
          <h2 className={"inline-block rounded-xl uppercase text-accent"}>
            Quick Links Click Below
          </h2>
          <ul className={"ml-4 list-square"}>
            <li>
              <Link to={"/about-us/"}>About Us</Link>
            </li>
            <li>
              <Link to={"/faq/"}>F.A.Q.</Link>
            </li>

            <li>
              <Link to={"/sell-consign-your-watch-in-miami/"}>
                Sell/Consign Your Watch in Miami
              </Link>
            </li>
            <li>
              <Link to={"/privacy-policy/"}>Privacy Policy</Link>
            </li>
            <li>
              <Link to={"/blog/"}>Blog</Link>
            </li>
            <li>
              <Link to={"/site-index/"}>Sitemap</Link>
            </li>
          </ul>
        </div>
        <div className={"flex-1 leading-8"}>
          <h2 className={"inline-block rounded-xl uppercase text-accent"}>Easy 3 Step Process </h2>
          <p>Click Below to Begin Step 1</p>
          <ul className={"ml-4 list-square"}>
            <li>
              <Link to={"/watch-quote/"}>Watch Quote </Link>
            </li>
            <li>
              <Link to={"/jewelry-quote/"}>Jewelry Quote</Link>
            </li>
            <li>
              <Link to={"/diamond-quote/"}>Diamond Quote</Link>
            </li>
            <li>
              <Link to={"/sterling-silver-quote/"}>Sterling Quote</Link>
            </li>
          </ul>
        </div>
      </nav>
      <section
        className={
          "container mx-2 my-4 flex justify-center border-t-2 border-black p-4 text-5xl md:mx-auto "
        }
      >
        <a href={"https://www.facebook.com/SellUsYourJewelry/"}>
          <IconFacebook />
        </a>
        <a href={"https://twitter.com/grayandsons"}>
          <IconTwitter />
        </a>
        <a href={"https://www.instagram.com/sellusyourjewelry"}>
          <IconInstagram />
        </a>
        <a href={"https://www.pinterest.com/grayandsons/"}>
          <IconGooglePlus />
        </a>
        <a href={"https://www.youtube.com/user/grayandsons"}>
          <IconYouTube />
        </a>
        <a href={"https://www.linkedin.com/company/gray-&-sons-jewelers"}>
          <IconLinkedIn />
        </a>
      </section>
      <section className={"container my-4 mx-auto whitespace-pre-line text-center text-sm"}>
        Gray & Sons Jewelers, Inc. 9595 Harding Ave, Bal Harbour, FL, 33154. Call Us:{" "}
        <a href={"tel:+13057706955"}>+1 305 770 6955</a>
        {"\n"}
        Created with care by{" "}
        <a target="_blank" rel={"noopener"} href={"https://www.dibbyglobal.com/"}>
          Dibby Global
        </a>
      </section>
    </footer>
  )
})

export default Footer
